import Cookie from "js-cookie";
import jwt from "jsonwebtoken";
import * as Constants from "../constants/Constants";

export const removeCookies = (removeRedirectTo = true) => {
    /**
     * Clears all data from cookie and localStorage
     */
    Cookie.remove("userName");
    Cookie.remove("email");    
    if (removeRedirectTo) {
      Cookie.remove("redirectTo");
    }
    Cookie.remove("token");
    Cookie.remove("X_TKN");
    localStorage.clear();
};

/**
 * Logout from the application.
 * Redirection is based on the userType
 */
export const logout = (removeRedirectTo = true) => {
    const nameid = Cookie.get("nameId");
    const nameidformat = Cookie.get("nameIdFormat");
    const sessionindex = Cookie.get("sessionIndex");
    removeCookies(removeRedirectTo);

    if (!nameid || !nameidformat || !sessionindex || !Cookie.get("userType")) {
      window.location.href = "/";
      return;
    }
    if (
      Cookie.get("userType") !== null &&
      Cookie.get("userType") === Constants.VP_USER_TYPE_INTERNAL
    ) {
      window.location = `/logout/${nameid}/${nameidformat}/${sessionindex}`;
    } else {
      window.location = `/samlLogout/${nameid}/${nameidformat}/${sessionindex}`;
    }
  };

export const isTokenValid = (X_TKN) => {
    /**
     * Decodes the token and checks whether the token has expired or not
     */
    let decodedToken = jwt.decode(X_TKN);
    if (decodedToken && decodedToken.exp < Math.ceil(new Date().getTime() / 1000)) {
        return false;
    } else {
        return true;
    }
}

export const isAuthenticated = () => {
    const { userName, email, userType, X_TKN } = Cookie.getJSON();
    let validSession = true;

    /**
     * Checks whether the required data are present in the cookie
     */
    if (!userName || !email || !userType || !X_TKN) {        
        validSession = false;
    }
    /**
     * If all the required data are present in the cookie,
     * then check the validity of the X_TKN
     */
    if (!isTokenValid(X_TKN)) {
        validSession = false;
    }

    return validSession;
}